export default __webpack_public_path__ + "static/media/store_outline_white.55a13cf1.svg";